import { X } from 'lucide-react';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ContactModal = ({ isOpen, onClose }: ContactModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">Contact Support</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4 text-gray-300">
          <div>
            <h3 className="font-semibold mb-1">Email</h3>
            <a href="mailto:support@bigtunatech.com" className="text-blue-400 hover:text-blue-300">
              support@bigtunatech.com
            </a>
          </div>

          <div>
            <h3 className="font-semibold mb-1">Phone</h3>
            <a href="tel:+1234567890" className="text-blue-400 hover:text-blue-300">
              (949) 282-7201
            </a>
          </div>

          <div>
            <h3 className="font-semibold mb-1">Hours of Operation</h3>
            <p>Monday - Friday: 9:00 AM - 5:00 PM PST</p>
          </div>

          <div className="text-sm text-gray-400 mt-6">
            <p>
              For urgent matters outside of business hours, please call us at (949) 282-7201 and we
              will assist you as soon as possible.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
